import { render, staticRenderFns } from "./Form812_v2.vue?vue&type=template&id=315b8e52&scoped=true&"
import script from "./Form812_v2.vue?vue&type=script&lang=js&"
export * from "./Form812_v2.vue?vue&type=script&lang=js&"
import style0 from "./Form812_v2.vue?vue&type=style&index=0&id=315b8e52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315b8e52",
  null
  
)

export default component.exports